import { FlowNavigationContext, flowPages, SignupFlowSlug } from "../constants";
/**
 * Returns the next eligible page in formFlow, based on constraint checks.
 * Skips pages that don't match current user/form state.
 * Used to drive the "Continue" button.
 * @param currentSlug - The current page slug
 * @param context - The information we pass into each requirement so it can
 *                  perform its validation
 * @returns The next eligible page slug, or null if no next page is found
 */
export function getNextPageSlug(currentSlug: string, context: FlowNavigationContext): SignupFlowSlug | null {
  const currentPageIndex = flowPages.findIndex((page) => page.slug === currentSlug);

  if (currentPageIndex === -1) {
    return null;
  }

  for (let i = currentPageIndex + 1; i < flowPages.length; i += 1) {
    const page = flowPages[i];
    const isVisible = page.accessRequirements.every((req) => req(context));

    if (isVisible) {
      return page.slug;
    }
  }

  return null;
}
